<ng-container [ngSwitch]="icon">
  <mat-icon *ngSwitchCase="'success'">check_circle</mat-icon>
  <mat-icon *ngSwitchCase="'warning'">warning</mat-icon>
  <mat-icon *ngSwitchCase="'info'">info</mat-icon>
  <mat-icon *ngSwitchCase="'error'">error</mat-icon>
</ng-container>

<div class="custom-snackbar-content">
  <h3>{{ title }}</h3>
  <p [innerHTML]="message"></p>
</div>
